import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, Col, Container, Label, Row } from 'reactstrap';
import { Link } from "react-router-dom";

// import images
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../../assets/images/users/avatar-7.jpg";

// import actions
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getFilteredDevice } from "../../../slices/veloxity/profile/FilterReducer";
import { getProfileTypes } from "../../../slices/veloxity/profile/ProfileTypeReducer";
import { findVeloxityDevices } from "../../../slices/veloxity/profile/FindDevicesReducer";
import { getDemographic } from "../../../slices/veloxity/profile/DemographicReducer";
import Skeleton from "react-loading-skeleton";
import Loader from "../../../components/common/Loader";

import BreadCrumb from '../../../components/common/BreadCrumb';

const ProfileMain = (props) => {

    let { items = [] } = useSelector((state) => state.filterDevice);
    const { totalCount } = useSelector((state) => state.filterDevice);

    const formattedTotalCount = new Intl.NumberFormat('en-US').format(totalCount);
    const dispatch = useDispatch();
    const [options, setOptions] = useState([]);

    // Subscription verisini almak
    const subscriptions = useSelector(state => state.getPermissionsList.subscriptions);

    // Kullanıcı Analitik abonesini almak
    const userAnalyticSubscription = subscriptions?.find(sub => sub.subscriptionType === "USER_ANALYTIC");

    // Filtre özelliklerine izin var mı kontrol et
    const hasFilterFeature = (feature) => {
        return userAnalyticSubscription?.featureFlags?.[feature] === true;
    };

    const [col1, setCol1] = useState(false);
    const t_col1 = () => {
        setCol1(!col1);
    };

    const { clientDeviceIds,
        clientDeviceId,
        deviceModel,
        gender,
        osType,
        personaName
    } = useSelector((state) => state.VeloxityFindDevices) || {};

    const purchasingFilterOptions = [
        { value: 'VERY_HIGH', label: 'Very High' },
        { value: 'HIGH', label: 'High' },
        { value: 'MODERATE', label: 'Moderate' },
        { value: 'LOW', label: 'Low' },
        { value: 'VERY_LOW', label: 'Very Low' }
    ]
    const genderOption = [
        { value: 'MALE', label: 'Male' },
        { value: 'FEMALE', label: 'Female' },
    ]

    const userStatusOptions = [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' }
    ]

    const generationFilterOptions = [
        { value: 'X', label: 'X' },
        { value: 'Y', label: 'Y' },
        { value: 'Z', label: 'Z' },
        { value: 'BABY_BOOMER', label: 'Baby Boomer' },
        { value: 'ALPHA', label: 'Alpha' }
    ]


    const [isLoading, setIsLoading] = useState(true);


    const [profileTypeValue, setProfileTypeValue] = useState([])
    const [genderValue, setGenderValue] = useState(null)
    const [generationValue, setGenerationValue] = useState([])
    const [purchasingPowerValue, setPurchasingPowerValue] = useState([])
    const [userStatusValue, setUserStatusValue] = useState(null)


    const [profileTypeOptions, setProfileTypeOptions] = useState([])

    const [isSearchUserId, setIsSearchUserId] = useState(false)

    const [selectUserIdValue, setSelectUserIdValue] = useState(null);
    const [selectGenderValue, setSelectGenderValue] = useState(null);
    const [selectGenerationValue, setSelectGenerationValue] = useState(null);
    const [selectUserStatusValue, setSelectUserStatusValue] = useState(null);
    const [selectPurchasingPowerValue, setSelectPurchasingPowerValue] = useState(null);
    const [selectProfileTypeValue, setSelectProfileTypeValue] = useState(null);
    const handleUserIdOnChange = async (e) => {

        if (e) {
            await setIsLoading(true);
            setIsSearchUserId(true);
            setSelectUserIdValue(e);
            setSelectGenderValue(null)
            setSelectGenerationValue(null)
            setSelectUserStatusValue(null)
            setSelectPurchasingPowerValue(null)
            setSelectProfileTypeValue(null)
            await dispatch(findVeloxityDevices({ deviceId: e.value }))
            await setIsLoading(false);
        } else {
            setIsSearchUserId(false);
        }

    };
    const handleUserIdInputChange = (inputValue) => {
        if (inputValue.length > 4) {
            dispatch(findVeloxityDevices({ deviceId: inputValue })).then((data) => {
                setOptions(data.payload.items.map((option) => ({
                    value: option.clientDeviceId,
                    label: option.clientDeviceId
                })));
            })

        }
        if (inputValue.length === 0) {
            const newOptions = [];
            setOptions(newOptions);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await setIsSearchUserId(false);
            await setIsLoading(true);
            await dispatch(getProfileTypes()).then(data => {

                setProfileTypeOptions(data.payload.items.map(item => (
                    {
                        value: item.code,
                        label: item.name,
                    }
                )));


            })

            await dispatch(getFilteredDevice(
                { gender: genderValue, generations: generationValue, userStatus: userStatusValue, purchasingPowers: purchasingPowerValue, personas: profileTypeValue }));

            await setIsLoading(false);
        };

        fetchData()

    }, [profileTypeValue, genderValue, generationValue, purchasingPowerValue, userStatusValue]);
    const onChangeProfileType = (e) => {
        setSelectProfileTypeValue(e);
        setSelectUserIdValue(null);
        setProfileTypeValue(e.map(option => option.value));
    };
    const onChangeGender = (e) => {
        if (e) {
            setSelectGenderValue(e);
            setSelectUserIdValue(null);
            setGenderValue(e.value);
        } else {
            setSelectGenderValue(null);
            setGenderValue(e);
        }
    };
    const onChangeGeneration = (e) => {
        setSelectGenerationValue(e);
        setSelectUserIdValue(null);
        setGenerationValue(e.map(option => option.value))
    };
    const onChangePurchasingPower = (e) => {
        setSelectPurchasingPowerValue(e);
        setSelectUserIdValue(null);
        setPurchasingPowerValue(e.map(option => option.value))
    };

    const onChangeUserStatus = (e) => {
        if (e) {
            setSelectUserStatusValue(e);
            setSelectUserIdValue(null);
            setUserStatusValue(e.value);
        } else {
            setSelectUserStatusValue(null);
            setUserStatusValue(e);
        }
    };


    const pageSize = 12;
    const maxButtons = isSearchUserId ? 1 : 5;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = isSearchUserId ? 1 : Math.ceil(items.length / pageSize);
    const searchValue = [{
        clientDeviceId: clientDeviceId,
        osType: osType,
        deviceModel: deviceModel,
        personaName: personaName,
        gender: gender
    }];
    let paginatedItems = isSearchUserId ? searchValue : items.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const changePage = (newPage) => {
        if (newPage < 1 || newPage > totalPages) {
            return;
        }
        setCurrentPage(newPage);
    };

    const getPageButtons = () => {
        const buttons = [];
        const halfMaxButtons = Math.floor(maxButtons / 2);
        const start = Math.max(1, currentPage - halfMaxButtons);
        const end = Math.min(totalPages, start + maxButtons - 1);

      
        const adjustedStart = Math.max(1, end - maxButtons + 1); 
        const finalStart = Math.max(1, Math.min(adjustedStart, totalPages - maxButtons + 1)); 
        const finalEnd = Math.min(finalStart + maxButtons - 1, totalPages);

        for (let i = finalStart; i <= finalEnd; i++) {
            buttons.push(
                <Button
                    key={i}
                    onClick={() => changePage(i)}
                    className={currentPage === i ? 'active' : ''}
                    style={{ margin: "2px", fontSize: "0.75rem", padding: "8px 14px" }}
                >
                    {i}
                </Button>
            );
        }

        return buttons;
    };

    const sortedProfileTypeOptions = profileTypeOptions.sort((a, b) => a.label.localeCompare(b.label));

    return (
        <React.Fragment>


            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="User Analytics" pageTitle="Customer Analytics" />
                    <Row>

                        <Col lg="3">

                            <Row>
                                <Col lg="11">
                                    <Card
                                        className="p-3"
                                        style={{
                                            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                            marginBottom: "30px",
                                        }}
                                    >
                                        <Row>
                                            {hasFilterFeature("filter::profile") && (
                                                <Col lg="12">
                                                    <Label className="text-muted" for="profileFilterOptions">
                                                        Profile Type
                                                    </Label>

                                                    <Select
                                                        options={sortedProfileTypeOptions} // Use sortedProfileTypeOptions
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        placeholder="Select Profile Type..."
                                                        onChange={onChangeProfileType}
                                                        value={selectProfileTypeValue}
                                                        styles={{
                                                            control: provided => ({
                                                                ...provided,
                                                                marginTop: '-10px',
                                                            }),
                                                        }}
                                                    />
                                                </Col>
                                            )}
                                            {hasFilterFeature("filter::purchasing_power") && (
                                                <Col lg="12" style={{ marginTop: "15px" }}>
                                                    <Label className="text-muted" for="purchasingFilterOptions">
                                                        Purchasing Power
                                                    </Label>

                                                    <Select
                                                        options={purchasingFilterOptions}
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        placeholder="Select Purchasing Type"
                                                        onChange={onChangePurchasingPower}
                                                        value={selectPurchasingPowerValue}
                                                        styles={{
                                                            control: provided => ({
                                                                ...provided,
                                                                marginTop: '-10px',
                                                            }),
                                                        }}
                                                    />
                                                </Col>
                                            )}

                                            {hasFilterFeature("filter::gender") && (
                                                <Col lg="12" style={{ marginTop: "15px" }}>
                                                    <Label className="text-muted" for="purchasingFilterOptions">
                                                        Gender
                                                    </Label>

                                                    <Select
                                                        options={genderOption}
                                                        isClearable={true}
                                                        placeholder="Select Gender"
                                                        onChange={onChangeGender}
                                                        value={selectGenderValue}
                                                        styles={{
                                                            control: provided => ({
                                                                ...provided,
                                                                marginTop: '-10px',
                                                            }),
                                                        }}
                                                    />
                                                </Col>

                                            )}
                                            {hasFilterFeature("filter::generation") && (
                                                <Col lg="12" style={{ marginTop: "15px" }}>
                                                    <Label className="text-muted" for="purchasingFilterOptions">
                                                        Generation
                                                    </Label>

                                                    <Select
                                                        options={generationFilterOptions}
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        placeholder="Select Generation Type"
                                                        onChange={onChangeGeneration}
                                                        value={selectGenerationValue}
                                                        styles={{
                                                            control: provided => ({
                                                                ...provided,
                                                                marginTop: '-10px',
                                                            }),
                                                        }}
                                                    />
                                                </Col>
                                            )}

                                            {hasFilterFeature("filter::user_status") && (
                                                <Col lg="12" style={{ marginTop: "15px" }}>
                                                    <Label className="text-muted" for="purchasingFilterOptions">
                                                        User Status
                                                    </Label>

                                                    <Select
                                                        options={userStatusOptions}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select User Status"
                                                        onChange={onChangeUserStatus}
                                                        value={selectUserStatusValue}
                                                        styles={{
                                                            control: provided => ({
                                                                ...provided,
                                                                marginTop: '-10px',
                                                            }),
                                                        }}
                                                    />
                                                </Col>
                                            )}
                                            <hr className="border-2 mx-auto" style={{ marginTop: "15px", marginBottom: "20px", width: "95%" }} />
                                            <Col lg="12" >
                                                <Label className="text-muted" for="deviceID">
                                                    User ID
                                                </Label>

                                                <Select
                                                    className="custom-select"
                                                    options={options}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder="Search DeviceID..."
                                                    onChange={handleUserIdOnChange}
                                                    noOptionsMessage={({ inputValue }) => inputValue.length < 5 ? 'Please enter at least 5 characters...' : 'No options found'}
                                                    onInputChange={handleUserIdInputChange}
                                                    value={selectUserIdValue}
                                                    styles={{
                                                        control: provided => ({
                                                            ...provided,
                                                            marginTop: '-10px',
                                                        }),
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>



                        </Col>

                        {isLoading ? (
                            <Col lg="9">
                                <div style={{ marginTop: "30%" }}>
                                    <Loader />
                                </div>

                            </Col>
                        ) : (

                            <>


                                <Col lg="9">
                                    <Row>
                                        <Card
                                            className="p-3"
                                            style={{
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                marginBottom: "30px",
                                                marginLeft: "1%",
                                                width: "98%",
                                                height: "90%"
                                            }}
                                        >
                                            <div style={{ fontWeight: 1000, fontSize: 14 }}>Total User Count: {formattedTotalCount}</div>
                                        </Card>
                                    </Row>

                                    <Row>

                                        {paginatedItems.map((member) => (
                                            <Col key={member.id} md={6} lg={4} xl={3} className="mb-2">
                                                <Card className="team-card" style={{ height: "330px" }}>
                                                    <CardBody className="text-center">
                                                        <div className="team-member-image mb-4">
                                                            <img
                                                                src={member.gender === "MALE" ? avatar1 : avatar2}
                                                                alt={member.clientDeviceId}
                                                                className="img-fluid rounded-circle team-profile-img-shadow"
                                                                style={{ width: '100px', height: '100px' }}
                                                            />
                                                        </div>

                                                        <h5 className="fs-11 text-muted font-weight-bold" style={{ fontSize: '1rem', marginTop: "20px" }}>
                                                            {member.clientDeviceId}
                                                        </h5>

                                                        <p className="fs-14 mb-0 text-center">
                                                            {member.osType} / {member.deviceModel}
                                                        </p>

                                                        <Col className="col">
                                                            <Row className="text-center profile-text" style={{ marginTop: "25px" }}>
                                                                <Col xs={12}>
                                                                    <p className="fs-16 mb-0">
                                                                        <b>{member.personaName}</b>
                                                                    </p>
                                                                </Col>
                                                            </Row>
                                                        </Col>

                                                        {/* Move the "View Profile" button here */}
                                                    </CardBody>

                                                    {/* "View Profile" button is now at the bottom of the Card */}
                                                    <Button
                                                        onClick={() => props.onProfileClick(member.clientDeviceId)}
                                                        className="btn btn-primary btn-s"
                                                        style={{ marginTop: "auto" }}
                                                        color="primary"
                                                    >
                                                        View Profile
                                                    </Button>
                                                </Card>
                                            </Col>
                                        ))}

                                        <div className="text-center">
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Button style={{ borderRadius: "15px 2px 2px 15px", fontSize: "0.75rem", padding: "7px 14px", marginRight: "4px" }}
                                                    onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                                                    Prev
                                                </Button>

                                                {getPageButtons()}

                                                <Button style={{ borderRadius: "2px 15px 15px 2px", fontSize: "0.75rem", padding: "7px 14px", marginLeft: "4px" }}
                                                    onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                                                    Next
                                                </Button>
                                            </div>
                                        </div>
                                    </Row>


                                </Col>
                            </>

                        )}



                    </Row>


                </Container>

            </div>

        </React.Fragment>
    );
};

export default ProfileMain;
